import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

import { SyrupProperties } from '@app/api/marketplace/models';
import { environment } from '@environments/environment';
import { SpecialProperties as SpecialProperty } from '@products/interfaces/special-properties';
import { LocalizedValueSubformComponent } from '@shared/components/localized-value-subform/localized-value-subform.component';
import { SubformBaseComponent } from '@shared/components/subform-base/subform-base.component';
import { eanNumberValidator } from '@shared/validators/ean-number.validator';

@Component({
  selector: 'app-product-variant',
  templateUrl: './product-variant.component.html',
  styleUrls: ['./product-variant.component.scss'],
})
export class ProductVariantComponent
  extends SubformBaseComponent
  implements OnInit
{
  DICT_PATH = 'PRODUCTS.PRODUCT_VARIANT';

  marketingLabels = SpecialProperty.MarketingLabelsEnum;
  experienceCategories = SpecialProperty.ExperienceCategoriesEnum;
  foodPairings = SpecialProperty.FoodPairingsEnum;

  get devMode(): boolean {
    return environment.dev;
  }

  generateRandomLengthNumber(length: number, controlName: string): void {
    const max = Math.pow(10, length) - 1;
    const min = Math.pow(10, length - 1);
    this.group.controls[controlName].patchValue(
      Math.floor(Math.random() * (max - min + 1) + min)
    );
  }

  static buildForm(fb: FormBuilder, data?: SyrupProperties) {
    return fb.group({
      name: ['', [Validators.required]],
      ean: ['', [Validators.required, eanNumberValidator]],
      grossWeightInKilograms: [
        0,
        [Validators.required, Validators.min(0.00001)],
      ],
      customerSegment: fb.group({
        manufacturersAllowed: fb.control(false),
        importersAllowed: fb.control(false),
        wholesalersAllowed: fb.control(false),
        retailers: fb.group({
          hotelsAllowed: fb.control(false),
          restaurantsAllowed: fb.control(false),
          cafesAllowed: fb.control(false),
          retailChainsAllowed: fb.control(false),
          trafiksAllowed: fb.control(false),
          otherRetailersAllowed: fb.control(false),
          hotelsAllowedModifiable: fb.control(true),
          restaurantsAllowedModifiable: fb.control(true),
          cafesAllowedModifiable: fb.control(true),
          retailChainsAllowedModifiable: fb.control(true),
          trafiksAllowedModifiable: fb.control(true),
          otherRetailersAllowedModifiable: fb.control(true),
        }),
        retailersAllowed: fb.control(false),
        retailersAllowedModifiable: fb.control(true),
        endConsumersAllowed: fb.control(false),
        endConsumersAllowedModifiable: fb.control(true),
        importersAllowedModifiable: fb.control(true),
        manufacturersAllowedModifiable: fb.control(true),
        wholesalersAllowedModifiable: fb.control(true),
      }),
      shortDescription: LocalizedValueSubformComponent.buildDefaultForm(),
      detailedDescription: LocalizedValueSubformComponent.buildDefaultForm(),
      marketingLabels: [null],
      experienceCategories: [null],
      foodPairings: [null],
    });
  }
}
